import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST, CONTENT_TYPE_FORM } from '../utils/config'

/**
 * 登录
 * @param account
 * @param password
 * @return {*}
 */
export function apiLogin (companyCode, account, password) {
  let params = {
    companyCode,
    account,
    password
  }

  return doHttp('/user/login.action', HTTP_TYPE_GET, params)
}

/**
 * 退出登录
 * @return {*}
 */
export function apiLogout () {
  return doHttp('/user/logout.action', HTTP_TYPE_GET)
}

/**
 * 修改密码
 * @param {*} id
 * @param {*} oldPwd
 * @param {*} newPwd
 */
export function apiChangePwd (id, oldPwd, newPwd, flag = 0) {
  let params = {
    id,
    oldPwd,
    newPwd,
    flag
  }
  return doHttp('/user/pwd.action', HTTP_TYPE_GET, params)
}

/**
 * 获取人员列表
 * @param {*} name
 * @param {*} status 0:未禁用 1:已禁用
 * @param {*} pageIndex
 * @param {*} pageSize
 */
export function apiGetList (name, status, pageIndex = 1, pageSize = 20) {
  let params = {
    name,
    status,
    pageIndex,
    pageSize
  }
  return doHttp('/user/list.action', HTTP_TYPE_GET, params)
}

/**
 * 删除
 * @param {*} id
 * @param {*} flag 1:禁用 2:删除
 */
export function apiDelete (id) {
  let params = {
    id,
    flag: 2
  }
  return doHttp('/user/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 禁用/启用
 * @param {*} id
 * @param {*} flag 1:禁用 2:删除
 */
export function apiSwitch (id) {
  let params = {
    id,
    flag: 1
  }
  return doHttp('/user/delete.action', HTTP_TYPE_GET, params)
}

/**
 * 新增或编辑
 * @param {*} params
 */
export function apiEdit (params) {
  return doHttp('/user/edit.action', HTTP_TYPE_POST, params)
}
